import { ShareholderRecord, SharpAuthorizationExpanded, SharpAuthorizationPermission } from './shareholder.types';

export const shareholderRecordsMock: ShareholderRecord[] = [
    {
        nsId: 0,
        shareholder: 'Shareholder 0',
        email: 'curtis.weaver@example.com',
        address1: '1234 Wiajfe Street',
        address2: 'Denver CO 12346',
    },
    {
        nsId: 1,
        shareholder: 'Shareholder 1',
        email: 'curtis.weaver@example.com',
        address1: '1234 Wiajfe Street',
        address2: 'Denver CO 12346',
    },
    {
        nsId: 2,
        shareholder: 'Shareholder 2',
        email: 'curtis.weaver@example.com',
        address1: '1234 Wiajfe Street',
        address2: 'Denver CO 12346',
    },
    {
        nsId: 3,
        shareholder: 'Shareholder 3',
        email: 'curtis.weaver@example.com',
        address1: '1234 Wiajfe Street',
        address2: 'Denver CO 12346',
    },
];

export const shareholderUserAccessRecordsMock: SharpAuthorizationExpanded[] = [
    {
        shareholder: 'Shareholder 1',
        shareholderId: 1,
        deal: 'Project Deal 10',
        dealId: 10,
        firstName: 'Some',
        middleName: null,
        lastName: 'User 100',
        userId: 100,
        nsContactName: 'Some User 100',
        permission: SharpAuthorizationPermission.Owner,
    },
    {
        shareholder: 'Shareholder 2',
        shareholderId: 2,
        deal: 'Project Deal 20',
        dealId: 20,
        firstName: 'Some',
        middleName: null,
        lastName: 'User 200',
        userId: 200,
        nsContactName: 'Some User 200',
        permission: SharpAuthorizationPermission.Administrator,
    },
    {
        shareholder: 'Shareholder 3',
        shareholderId: 3,
        deal: 'Project Deal 30',
        dealId: 30,
        firstName: 'Some',
        middleName: null,
        lastName: 'User 300',
        userId: 300,
        nsContactName: 'Some User 300',
        permission: SharpAuthorizationPermission.Inviter,
    },
    {
        shareholder: 'Shareholder 4',
        shareholderId: 4,
        deal: 'Project Deal 40',
        dealId: 40,
        firstName: 'Some',
        middleName: null,
        lastName: 'User 400',
        userId: 400,
        nsContactName: 'Some User 400',
        permission: SharpAuthorizationPermission.Viewer,
    },
];
